import React from 'react'
import BentoRepositoryListCard from '@/components/BentoRepositoryListCard'

export default function OrganizationBentoRepositories() {
    return <BentoRepositoryListCard />
}
